import { useMessages } from "../hooks";
import { MessagesPanel } from "@/shared/components";

export function MessagesList() {
  const { data, isLoading, error, fetchNextPage, hasNextPage, isFetchingNextPage } = useMessages();

  const allMessages = data?.pages.flatMap(page => page.data) || [];

  return (
    <MessagesPanel
      title="All Messages"
      messages={allMessages}
      isLoading={isLoading}
      isError={!!error}
      error={error || null}
      reserveComposerSpace
    />
  );
}
